<template>
  <div class="bank-card" :class="{ 'is-selected': selected }" @click="$emit('edit', bank)">
    <div class="bank-card-header">
      <div class="bank-card-checkbox" @click.stop>
        <b-form-checkbox :checked="selected" @change="$emit('select', bank)" />
      </div>
      <div class="bank-card-logo">
        <img v-if="showLogo" :src="bank.urlLogo" @error="logoError = true" />
        <i v-else class="fa-solid fa-building-columns"></i>
      </div>
      <div class="bank-card-info">
        <Tooltip :title="name">
          <span class="bank-card-name">{{ name }}</span>
        </Tooltip>
      </div>
    </div>

    <div class="bank-card-footer">
      <span class="bank-card-number">{{ bank.number }}</span>
      <div class="bank-card-buttons">
        <Tooltip title="Editar Banco">
          <span class="bank-card-btn" @click.stop="$emit('edit', bank)">
            <i class="fa-solid fa-pen-to-square"></i>
          </span>
        </Tooltip>
        <Tooltip title="Excluir Banco">
          <span class="bank-card-btn bank-card-btn-danger" @click.stop="$emit('delete', bank)">
            <i class="fa-solid fa-trash"></i>
          </span>
        </Tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from "@/ui/layout/Tooltip";

export default {
  name: "BankCard",
  components: { Tooltip },
  props: {
    bank: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logoError: false,
    };
  },
  computed: {
    name() {
      return this.bank.name || this.bank.nameFull;
    },
    showLogo() {
      return !!this.bank.urlLogo && !this.bank.urlLogo.endsWith("/") && !this.logoError;
    },
  },
};
</script>

<style scoped>
.bank-card {
  background: var(--bg-base);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  width: 320px;
  padding: 16px 20px;
  cursor: pointer;
  transition: box-shadow 0.15s, border-color 0.15s, transform 0.15s;
}

.bank-card:hover {
  box-shadow: var(--shadow-sm);
  transform: translateY(-1px);
}

.bank-card.is-selected {
  border-color: var(--color-brand);
}

.bank-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  min-width: 0;
}

.bank-card-checkbox {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.bank-card-checkbox>>>.custom-control {
  margin: 0;
}

.bank-card-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: var(--bg-elevated);
  color: var(--color-brand);
  font-size: 16px;
  flex-shrink: 0;
  overflow: hidden;
}

.bank-card-logo>>>img {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  object-fit: cover;
}

.bank-card-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.bank-card-info>>>.nx-tooltip-trigger {
  display: block;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.bank-card-name {
  display: block;
  max-width: 100%;
  font-size: 15px;
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bank-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  border-top: 1px solid var(--border-subtle);
}

.bank-card-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  padding: 3px 12px;
  border-radius: 999px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-subtle);
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.bank-card-buttons {
  display: flex;
  align-items: center;
  gap: 14px;
}

.bank-card-btn {
  font-size: 16px;
  cursor: pointer;
  color: var(--text-muted);
  transition: color 0.15s;
}

.bank-card-btn:hover {
  color: var(--color-brand);
}

.bank-card-btn-danger {
  color: var(--color-danger);
}
</style>
